import type { components } from '@/generated/internal-api/openapi-types';

export type AuditLogRow = components['schemas']['AuditLogV1'];
export type AuditLogEntityType = components['schemas']['AuditLogEntityType'];
export type AuditLogOperation = components['schemas']['AuditLogOperation'];

export const TENANT_AUDIT_LOG_ENTITY_TYPES = [
  'STUDY_USER_GROUP',
  'USER_GROUP',
  'USER_GROUP_MEMBERSHIP',
] as const satisfies ReadonlyArray<AuditLogEntityType>;

export const STUDY_AUDIT_LOG_ENTITY_TYPES = [
  'ANIMAL',
  'ANIMAL_ALERT',
  'ANIMAL_DEFINITION',
  'CAGE',
  'CAGE_METRIC',
  'DOSAGE',
  'EXPORT',
  'MEASUREMENT',
  'OBSERVATION',
  'SAMPLE',
  'SAMPLE_DEFINITION',
  'STUDY',
  'STUDY_ALERT',
] as const satisfies ReadonlyArray<AuditLogEntityType>;

export const AUDIT_LOG_OPERATIONS = [
  'CREATE',
  'UPDATE',
  'DELETE',
  'VIEW',
] as const satisfies ReadonlyArray<AuditLogOperation>;

export type AuditLogEntitySummary = components['schemas']['AuditLogEntitySummaryV1'];
export type AuditLogEntityHistory = components['schemas']['AuditLogEntityHistoryV1'];
export type AuditLogAnimalSummary = components['schemas']['AuditLogAnimalSummaryV1'];
export type AuditLogSampleSummary = components['schemas']['AuditLogSampleSummaryV1'];
export type AuditLogDosageSummary = components['schemas']['AuditLogDosageSummaryV1'];
export type AuditLogObservationSummary = components['schemas']['AuditLogObservationSummaryV1'];
export type AuditLogMeasurementSummary = components['schemas']['AuditLogMeasurementSummaryV1'];
